import React from "react";
import useReveal from "../hooks/useReveal";
import { useContent } from "../context/ContentContext";

function initials(name) {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export default function Team() {
  const [ref, inView] = useReveal();
  const { content } = useContent();
  const team = content.team;
  const bookUrl = content.settings.bookUrl;

  return (
    <section id="team" className="bg-[#0C0C0C] py-24 md:py-32 px-6">
      <div ref={ref} className={`max-w-6xl mx-auto reveal ${inView ? "in-view" : ""}`}>
        <div className="flex items-center gap-4 mb-3">
          <span className="text-xs tracking-[0.25em] text-[#C6A15B] uppercase">/ 04</span>
          <span className="gold-divider" />
          <span className="text-xs tracking-[0.25em] text-[#8A857A] uppercase">
            Advanced Practice Registered Nurses
          </span>
        </div>

        <h2 className="font-serif-display text-4xl md:text-6xl text-[#F7F2EA] mb-5">Our Team</h2>
        <p className="text-[#9E988B] font-light max-w-2xl mb-14 leading-relaxed">
          A team of skilled professionals dedicated to exceptional care and expertise in medical
          aesthetics — led by experienced advanced practice registered nurses and certified
          skincare specialists.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {team.map((m) => (
            <div
              key={m.id || m.name}
              className="service-card group border border-[#252525] bg-[#111111] hover:border-[#C6A15B]/60 overflow-hidden"
            >
              <div className="relative aspect-[3/4] overflow-hidden bg-[#161616]">
                {m.photo ? (
                  <img
                    src={m.photo}
                    alt={m.name}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <div className="h-24 w-24 rounded-full border border-[#C6A15B]/50 flex items-center justify-center">
                      <span className="font-serif-display text-3xl text-[#C6A15B]">
                        {initials(m.name)}
                      </span>
                    </div>
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0C0C0C] via-transparent to-transparent opacity-70" />
              </div>
              <div className="p-5 text-center">
                <h3 className="font-serif-display text-xl text-[#F7F2EA] leading-tight">
                  {m.name}
                </h3>
                <p className="text-[11px] tracking-[0.18em] uppercase text-[#8A857A] mt-2">
                  {m.role}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href={bookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-[#C6A15B] text-[#C6A15B] text-xs tracking-[0.2em] uppercase px-9 py-4 hover:bg-[#C6A15B] hover:text-[#0C0C0C] transition-colors"
          >
            Book With Our Team
          </a>
        </div>
      </div>
    </section>
  );
}
